import { ModelName, TableColumnType } from 'webapp/enums/enums';

import type { BlockRecord } from 'webapp/models';
import Block from 'webapp/models-custom/block';
import type BlockPreviewRecord from 'webapp/models/block-preview';

import ModelManagerForStoreService from 'webapp/services/model-manager/for-store';

export default class ModelManagerBlockPreviewsService extends ModelManagerForStoreService<
	BlockPreviewRecord,
	Block
> {
	getTableBlocksThatMustSwitchToAutoOnMasterDimensionsChange(
		blocks: Block[],
		dimensions: string[] | null,
		assumeTableVisualization = false, // used when checking before switching visualizations
	) {
		const dimensionsCount = dimensions?.length ?? 0;
		if (dimensionsCount === 0) {
			return [];
		}
		const hasMultipleDimensions = dimensionsCount > 1;

		return blocks.filter((block) => {
			const blockSetup = block.blockSetup;
			if (!blockSetup.visualization.isTable && !assumeTableVisualization) {
				return false;
			}

			if (block.tableColumnType === TableColumnType.SINGLE) {
				const hasMultipleMetrics = blockSetup.dataSelectsShown.length > 1;
				return hasMultipleDimensions || hasMultipleMetrics;
			}

			return false;
		});
	}

	// ------ For-store ------

	modelName = ModelName.BLOCK_PREVIEW;

	createModel(model: BlockPreviewRecord): Block {
		// assert just to appease Typescript
		return new Block({ model: model as BlockRecord });
	}
}

declare module '@ember/service' {
	interface Registry {
		'model-manager/block-previews': ModelManagerBlockPreviewsService;
	}
}
